module.exports = __webpack_public_path__ + "static/media/pm_chat_icon.256df8c4.svg";